import React from "react";
import {
  Box,
  Grid,
  Divider,
  useTheme,
  useMediaQuery,
  Container,
} from "@mui/material";
import { motion } from "framer-motion";
import {
  OrangeTitleQuickHighlights,
  SubTextQuickHighlights,
} from "../../styles/CustomTypography";
import { useInView } from "react-intersection-observer";

const CountryQuickHighlights = ({ stats = [] }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 60 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const [sectionRef, sectionInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <Container
      maxWidth="xl"
      sx={{
        py:{ xs: 2, sm: 2, md: 3 },
        px: { xs: 3, sm: 4, md: 6 },
        paddingLeft: { xs: "24px !important", md: "48px !important" },
        paddingRight: { xs: "24px !important", md: "48px !important" },
      }}
    >
      <Box
        component={motion.div}
        ref={sectionRef}
        variants={containerVariants}
        initial="hidden"
        animate={sectionInView ? "visible" : "hidden"}
        sx={{
          background: "linear-gradient(90deg, #053770 70%, #002045 100%)",
          borderRadius: "16px",
          p: 1,
        }}
      >
        <Grid
          container
          alignItems="flex-start"
          justifyContent="center"
          sx={{
            flexWrap: isTablet  ? "wrap" : "nowrap",
            textAlign: "center",
          }}
        >
          {stats.map((item, index) => (
            <React.Fragment key={index}>
              <Grid
                component={motion.div}
                variants={itemVariants}
                size={{ xs: 12, sm: 6, md: 12 / stats.length }}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  px: { xs: 1, md: 2 },
                  py: { xs: 2, md: 3 },
                }}
              >
                <OrangeTitleQuickHighlights sx={{ fontSize: { xs: "16px", sm: "18px" }, mb:'5px', }}>
                  {item.title}
                </OrangeTitleQuickHighlights>

                <SubTextQuickHighlights sx={{ fontSize: { xs: "14px", sm: "16px" }, }}>
                  {item.subtitle}
                </SubTextQuickHighlights>
              </Grid>

              {index < stats.length - 1 && (
                <Divider
                  orientation={isTablet  ? "horizontal" : "vertical"}
                  flexItem
                  sx={{
                    borderColor: "#ffffff",
                    mx: isTablet  ? 0 : 2,
                    my: isTablet  ? 1 : 0,
                    width: isTablet  ? "60%" : "auto",
                    alignSelf: isTablet  ? "center" : "stretch",
                  }}
                />
              )}
            </React.Fragment>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default CountryQuickHighlights;